export default "__VITE_ASSET__BTzW5J_t__"